/**
 * WestPoint Home Bahrain — Theme JS
 * Vanilla JS, no dependencies
 */
(function() {
  'use strict';

  function initMobileNav() {
    var mobileToggle = document.querySelector('[data-mobile-toggle]');
    var mobileNav = document.querySelector('[data-mobile-panel]');
    var mobileOverlay = document.querySelector('[data-mobile-overlay]');
    var mobileClose = document.querySelector('[data-mobile-close]');
    var previousFocus = null;

    if (!mobileToggle || !mobileNav) return;

    function getFocusableElements() {
      return Array.prototype.slice.call(
        mobileNav.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])')
      );
    }

    function setOpenState(isOpen) {
      mobileNav.classList.toggle('active', isOpen);
      if (mobileOverlay) mobileOverlay.classList.toggle('active', isOpen);
      mobileToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      mobileNav.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
      document.body.style.overflow = isOpen ? 'hidden' : '';
    }

    function openMobileNav() {
      previousFocus = document.activeElement;
      setOpenState(true);
      var focusables = getFocusableElements();
      if (focusables.length) focusables[0].focus();
    }

    function closeMobileNav() {
      setOpenState(false);
      if (previousFocus && typeof previousFocus.focus === 'function') {
        previousFocus.focus();
      }
    }

    function handleMobileNavKeydown(event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        closeMobileNav();
        return;
      }

      if (event.key !== 'Tab' || !mobileNav.classList.contains('active')) return;

      var focusables = getFocusableElements();
      if (!focusables.length) return;

      var first = focusables[0];
      var last = focusables[focusables.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    mobileToggle.addEventListener('click', openMobileNav);
    if (mobileClose) mobileClose.addEventListener('click', closeMobileNav);
    if (mobileOverlay) mobileOverlay.addEventListener('click', closeMobileNav);
    mobileNav.addEventListener('keydown', handleMobileNavKeydown);
    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape' && mobileNav.classList.contains('active')) {
        closeMobileNav();
      }
    });
  }

  function initHeaderScroll() {
    var header = document.querySelector('[data-header]');
    if (!header) return;

    function handleScroll() {
      var y = window.pageYOffset || document.documentElement.scrollTop;
      header.classList.toggle('header-scrolled', y > 80);
    }

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
  }

  function initAccordion() {
    document.addEventListener('click', function(event) {
      var trigger = event.target.closest('[data-accordion-trigger]');
      if (!trigger) return;

      var content = trigger.nextElementSibling;
      var icon = trigger.querySelector('[data-accordion-icon]');
      if (!content) return;

      var isOpen = content.style.maxHeight && content.style.maxHeight !== '0px';
      content.style.maxHeight = isOpen ? '0px' : content.scrollHeight + 'px';
      content.style.overflow = 'hidden';
      content.style.transition = 'max-height 0.3s ease';
      trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');

      if (icon) {
        icon.style.transform = isOpen ? 'rotate(0deg)' : 'rotate(180deg)';
      }
    });
  }

  function initCartHelpers() {
    if (!window.WPH || !window.WPH.routes) return;

    function addToCart(variantId, quantity) {
      return fetch(window.WPH.routes.cart_add, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: quantity || 1 }] })
      })
      .then(function(response) { return response.json(); })
      .then(function(data) {
        updateCartCount();
        return data;
      });
    }

    function updateCartCount() {
      return fetch(window.WPH.routes.cart_get)
        .then(function(response) { return response.json(); })
        .then(function(cart) {
          var badges = document.querySelectorAll('[data-cart-count]');
          badges.forEach(function(badge) {
            badge.textContent = cart.item_count;
            badge.style.display = cart.item_count > 0 ? 'flex' : 'none';
          });
        })
        .catch(function() {
        });
    }

    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(window.WPH.currencyDecimals);
      return window.WPH.locale === 'ar' ? amount + ' د.ب' : window.WPH.currency + ' ' + amount;
    }

    window.WPH.addToCart = addToCart;
    window.WPH.updateCartCount = updateCartCount;
    window.WPH.formatMoney = formatMoney;

    updateCartCount();
  }

  function initSmoothScroll() {
    document.addEventListener('click', function(event) {
      var link = event.target.closest('a[href^="#"]');
      if (!link) return;

      var id = link.getAttribute('href').slice(1);
      if (!id) return;

      var target = document.getElementById(id);
      if (!target) return;

      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  function initLazyMedia() {
    if (!('IntersectionObserver' in window)) return;

    var imageObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) return;

        var img = entry.target;
        if (img.dataset.src) {
          img.src = img.dataset.src;
          img.removeAttribute('data-src');
        }
        imageObserver.unobserve(img);
      });
    }, { rootMargin: '200px' });

    document.querySelectorAll('img[data-src]').forEach(function(img) {
      imageObserver.observe(img);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initMobileNav();
      initHeaderScroll();
      initAccordion();
      initCartHelpers();
      initSmoothScroll();
      initLazyMedia();
    });
  } else {
    initMobileNav();
    initHeaderScroll();
    initAccordion();
    initCartHelpers();
    initSmoothScroll();
    initLazyMedia();
  }
})();
